import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export default function TablaProductos({ datosCompra }) {
  return (
    <TableContainer style={{ maxHeight: "50vh" }} component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Producto</TableCell>
            <TableCell align="right">Cantidad</TableCell>
            <TableCell align="right">Precio</TableCell>
            <TableCell align="right">Importe</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {datosCompra.map(({ producto }) => (
            <TableRow
              key={producto.nombre}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {producto.nombre}
              </TableCell>
              <TableCell align="right">{producto.cantidad}</TableCell>
              <TableCell align="right">
                {`$${producto.precio.toFixed(2)}`}
              </TableCell>
              <TableCell align="right">
                {`$${producto.importe.toFixed(2)}`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
